import { getTermValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

export const mortgage: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('ipoteka')(jsonQuery);
    if (!value) {
      return null;
    }

    return [
      {
        group: 'mortgage',
        text: 'Возможна ипотека',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setMortgageAvailable',
      arguments: [null],
    });
  },
};
